import React from 'react'
import AlternativesContainer from './AlternativesContainer'
import {
  fetchAlternativesRequest,
  updateAlternatives
} from '../../actionCreators/alternatives/alternativesActionCreators'
import {
  fetchAvAlternativesRequest,
  updateAvAlternatives
} from '../../actionCreators/avAlternatives/avAlternativesActionCreator'
import {
  fetchShopCollectionRequest,
  updateShopCollection
} from '../../actionCreators/shopCollection/shopCollectionActionCreators'

const options = {
  alternatives: {
    headline: '...Or how about these?',
    fetchRequest: fetchAlternativesRequest,
    updateRequest: updateAlternatives
  },
  avAlternatives: {
    headline: 'These are in stock for you...',
    fetchRequest: fetchAvAlternativesRequest,
    updateRequest: updateAvAlternatives,
    hasContainer: false
  },
  shopCollection: {
    headline: 'Shop the collection',
    fetchRequest: fetchShopCollectionRequest,
    updateRequest: updateShopCollection
  }
}

function AlternativesHOC(props) {
  const { type } = props
  const relevantOptions = options[type]
  return <AlternativesContainer {...{ ...relevantOptions, ...props }} />
}

export default AlternativesHOC
